import {
  useState,
  type ChangeEventHandler,
  type InputHTMLAttributes,
} from "react";
import { IconEye, IconEyeOff } from "./BenchmarkIcons";

type PasswordInputWithToggleProps = {
  id: string;
  name: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onFocus?: InputHTMLAttributes<HTMLInputElement>["onFocus"];
  autoComplete?: InputHTMLAttributes<HTMLInputElement>["autoComplete"];
  maxLength?: number;
  required?: boolean;
};

export function PasswordInputWithToggle({
  id,
  name,
  value,
  onChange,
  onFocus,
  autoComplete,
  maxLength,
  required,
}: PasswordInputWithToggleProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="oac-password-input">
      <input
        autoComplete={autoComplete}
        id={id}
        maxLength={maxLength}
        name={name}
        onChange={onChange}
        onFocus={onFocus}
        required={required}
        type={visible ? "text" : "password"}
        value={value}
      />

      <button
        aria-label={visible ? "Hide password" : "Show password"}
        className="oac-password-input__toggle"
        onClick={() => setVisible((current) => !current)}
        type="button"
      >
        {visible ? (
          <IconEyeOff className="oac-password-input__icon" size={16} />
        ) : (
          <IconEye className="oac-password-input__icon" size={16} />
        )}
      </button>
    </div>
  );
}
